import { FolderDto } from "../api/psc";

export function validateFolderName(folder: FolderDto): string | null {
    if (folder.title.length < 1) {
        return "نام پوشه صحیح نیست";
    }

    return null;
}
